<app-header></app-header>
<!-- ======= Hero Section ======= -->
<section id="hero" class="d-flex flex-column justify-content-end align-items-center">
    <div id="heroCarousel" class="container carousel carousel-fade" data-ride="carousel">

        <!-- Titulo -->
        <div class="carousel-item active">
            <div class="carousel-container" style="height: 100%;">
                <h2 class="mt-4 animate__animated animate__faster animate__fadeInDown" style="margin-bottom: 0px;">
                    Reportar un Problema
                </h2>

                <p class="d-block d-sm-block d-md-none" style="font-size: 0.65rem;margin-bottom: 0px;">Soporte Tecnico</p>
                <p class="d-none d-sm-none d-md-block" style="margin-bottom: 0px;">Soporte Tecnico</p>

                <section id="services" class="services" style="padding: 1rem;width: 100%;">
                    <app-loader *ngIf="isLoading"></app-loader>
                    <div *ngIf="!isLoading">

                            <div class="form-row mt-3">
                              <div class="form-group col-md-6">
                                <label class="text-white">Nombre y Apellido</label>
                                <input type="text" id="nombre" required class="form-control" placeholder="Ingrese su nombre">
                              </div>
                              <div class="form-group col-md-6">
                                <label class="text-white">Email</label>
                                <input type="email" id="email" required class="form-control" placeholder="Ingrese su Email">
                              </div>
                            </div>
                            <div class="form-group">
                              <label class="text-white">Información de su Problema</label>
                              <textarea class="form-control" id="problema" required rows="3"></textarea>
                            </div>
                            <a (click)="enviar()" class="btn-get-started">Enviar problema</a>
 
                    </div>
                </section><!-- End Services Section -->
            </div>
        </div>
    </div>

    <svg class="hero-waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 24 150 28 " preserveAspectRatio="none">
        <defs>
            <path id="wave-path" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
        </defs>
        <g class="wave1">
            <use xlink:href="#wave-path" x="50" y="3" fill="rgba(255,255,255, .1)" />
        </g>
        <g class="wave2">
            <use xlink:href="#wave-path" x="50" y="0" fill="rgba(255,255,255, .2)" />
        </g>
        <g class="wave3">
            <use xlink:href="#wave-path" x="50" y="9" fill="#fff" />
        </g>
    </svg>


</section><!-- End Hero -->